import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import * as PusherMessages from '../../../services/pusher-service/pusher-contract-messages';
import { PusherService } from '../../../services/pusher-service';

import { createFallbackListeners } from './message-fallback-options';

const bulkUpdateMessageTypes = [
  PusherMessages.BULK_UPDATE_JOB_UPDATE,
  PusherMessages.BULK_UPDATE_ADD_TAX_IDS_JOB_STATUS,
  PusherMessages.BULK_UPDATE_SHIPPING_CONFIGURATION_JOB_COMPLETE,
  PusherMessages.BULK_UPDATE_SALES_ORDER_JOB_COMPLETE,
  PusherMessages.BULK_UPDATE_TEMPLATE_JOB_COMPLETE,
  PusherMessages.BULK_UPDATE_DO_NOT_NOTIFY_MARKETPLACE_JOB_COMPLETE,
  PusherMessages.BULK_ACTION_ADD_WEIGHT,
  PusherMessages.BULK_UPDATE_ADD_NOTE_COMPLETE,
  PusherMessages.BULK_UPDATE_SHIP_BY_DATE_COMPLETE,
];

export const bindToPusherEvents = (eventHandler, fallbackOptions) => {
  bulkUpdateMessageTypes.forEach((messageType) => {
    PusherService.bindToEvent(messageType, eventHandler, undefined, fallbackOptions);
  });
};

const unbindFromPusherEvents = (eventHandler) => {
  bulkUpdateMessageTypes.forEach((messageType) => {
    PusherService.unbindFromEvent(messageType, eventHandler);
  });
};

export const createEventBindingsWithFallback = () => {
  const { jobGuidManager, fallbackOptions } = createFallbackListeners();
  const pusherMsg$ = new Subject();
  const eventHandler = (msg) => {
    pusherMsg$.next(msg);
  };
  bindToPusherEvents(eventHandler, fallbackOptions);

  return {
    pusherMsg$: pusherMsg$.pipe(
      finalize(() => {
        unbindFromPusherEvents(eventHandler);
      }),
    ),
    jobGuidManager,
  };
};

export const getIsJobComplete = (pusherMsg) => {
  const { isComplete } = pusherMsg.data || {};

  return isComplete || isComplete == null;
};
